// extracted by mini-css-extract-plugin
module.exports = {"footer":"EditGroupInfoModal_footer__28IYb","label":"EditGroupInfoModal_label__1QSbM"};